<div class="package-content package-details">
  <div class="details">
    <div class="detail-item">
      <div class="label">Package ID</div>
      <div class="value">{{ submittalPackage()?.package_name ?? '-' }}</div>
    </div>

    <div class="detail-item">
      <div class="label">Project ID</div>
      <div class="value">{{ submittalPackage()?.project?.custom_project_id ?? '-' }}</div>
    </div>

    <div class="detail-item">
      <div class="label">Project Name</div>
      <div class="value">{{ submittalPackage()?.project?.title ?? '-' }}</div>
    </div>

    <div class="detail-separator"></div>

    <div class="detail-item">
      <div class="label">Manager</div>
      <div class="value">
        <span>{{ submittalPackage()?.package_manager?.name ?? '-' }}</span>
        <span class="second-value">{{ submittalPackage()?.package_manager?.company_name ?? '-' }}</span>
      </div>
    </div>

    <div class="detail-separator"></div>

    <div class="detail-item">
      <div class="label">Approving</div>
      <div class="value">
        <span>{{ submittalPackage()?.package_approver?.name ?? '-' }}</span>
        <span class="second-value">{{ submittalPackage()?.package_approver?.company_name ?? '-' }}</span>
      </div>
    </div>

    <div class="detail-separator"></div>

    <div class="detail-item">
      <div class="label">Sent For</div>
      <div class="value">
        <span>{{ submittalPackage()?.sent_for ?? '-' }}</span>
      </div>
    </div>

    <div class="detail-item">
      <div class="label">Received</div>
      <div class="value">{{ (submittalPackage()?.received_submittals_at | dayjsFormatter) ?? '-' }}</div>
    </div>

    <div class="detail-item">
      <div class="label">Responded</div>
      <div class="value">{{ (submittalPackage()?.received_approval_at | dayjsFormatter) ?? '-' }}</div>
    </div>

    <div class="detail-item">
      <div class="label">Due</div>
      <div class="value">{{ (submittalPackage()?.due_date | dayjsFormatter) ?? '-' }}</div>
    </div>
  </div>

  <div class="submittals-column">
    @for (submittal of submittalPackage()?.entries; track $index) {
      <div class="submittal-item text-navy-900 font-normal text-size_m">
        <div class="item">
          <app-faded-text class="font-semibold text-size_xl">{{ submittal?.item_description }}</app-faded-text>
          <app-faded-text class=""
            >{{ submittal?.custom_id }} - {{ submittal?.spec_section }}
            {{ submittal?.spec_description }}</app-faded-text
          >
        </div>
        <div class="item">
          <app-faded-text class="font-semibold text-size_xl">{{ submittal?.owner?.name }}</app-faded-text>
          <app-faded-text>{{ submittal?.owner?.company_name }}</app-faded-text>
        </div>
        <div class="item flex items-center justify-center">
          <app-status-block [status]="submittal?.status"></app-status-block>
        </div>
      </div>
    }
  </div>
</div>
